import React from 'react';
import {AboutMeStyle, TextStyle} from '../assets/css/Styles';
import {ProgressBar, Col} from 'react-bootstrap';

/**
 *
 * @param {Object} props - props for each project component
 * @return {Component} each project component
 */
export default function ProgressBarComponent({...props}) {
  return (
    <Col style={AboutMeStyle.eachProgressDiv}>
      <Col style={AboutMeStyle.progressBarTextDiv}>
        <span style={TextStyle.subTitleTxt3}>{props.title}</span>
      </Col>
      <ProgressBar
        animated
        now={props.percentage}
        label={`${props.percentage}%`}
        striped={true}
        variant='info'
        style={AboutMeStyle.eachProgressBar}
      />
    </Col>
  );
}
